import axios from 'axios';
import {backendHost} from '../../config';

export const getMailingStatisticsScrollerUsersWithdrawals = (params) => {
    return axios.get(`${backendHost}/api/admin/v2/mailing/scrollers/withdrawals/list`, {params});
};